import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const RollbackBuildStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({ stepRun }) => {
    return <div>Rollback Build Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
